import type { CSSProperties } from "react";

/** 画面上端と中身の間隔。サイドバーと各ペインが自分の背景色でこの余白を描く (エディタのタブ帯は上端に付ける)。 */
export const TOP_GAP = 5;

/** セクションヘッダの行の高さ。アイコンボタンの有無で行が伸び縮みしないよう固定する。 */
export const SECTION_HEADER_MIN_HEIGHT = 32;

/** LeftPane 下段パネル (ファイルツリー/検索) 共通のセクションヘッダスタイル。 */
export const SECTION_HEADER_STYLE: CSSProperties = {
	display: "flex",
	alignItems: "center",
	justifyContent: "space-between",
	fontSize: "var(--text-caption)",
	fontWeight: 500,
	letterSpacing: "var(--tracking-label)",
	textTransform: "uppercase",
	color: "var(--fg-3)",
	padding: "8px 12px 4px",
	minHeight: SECTION_HEADER_MIN_HEIGHT,
};

/** セクションヘッダの見出しラベル。幅が足りないときは折り返さず省略記号でたたむ。 */
export const SECTION_HEADER_LABEL_STYLE: CSSProperties = {
	minWidth: 0,
	overflow: "hidden",
	textOverflow: "ellipsis",
	whiteSpace: "nowrap",
};

/**
 * 段の上端に見出しを固定するラッパー。左ペインの背景色を敷いて、下を通る行を隠す。
 * ファイルツリー・検索の見出しは段のスクロール領域の中身なので、これがないと一緒に流れる。
 */
export const STICKY_HEADER_STYLE: CSSProperties = {
	position: "sticky",
	top: 0,
	zIndex: 1,
	background: "var(--surface-1)",
};

/** タスク一覧の状態バッジの形状。色は状態ごとのスタイルを重ねて決める。 */
export const BADGE_STYLE: CSSProperties = {
	flexShrink: 0,
	fontSize: "var(--text-section)",
	fontWeight: 600,
	padding: "1px 8px",
	borderRadius: "var(--radius-full)",
	whiteSpace: "nowrap",
};

/** 異常終了 (失敗・タイムアウト) を示すバッジの配色。 */
export const DANGER_BADGE_STYLE: CSSProperties = {
	background: "var(--danger-subtle)",
	color: "var(--danger)",
};

/** 状態色を持たないバッジ (完了・停止など) の配色。 */
export const NEUTRAL_BADGE_STYLE: CSSProperties = {
	background: "var(--surface-2)",
	color: "var(--fg-2)",
	boxShadow: "var(--shadow-ring)",
};

/** カウントバッジ。円形にするため最小幅と行の高さを同じ値から作る。 */
const COUNT_BADGE_SIZE = 16;

export const COUNT_BADGE_STYLE: CSSProperties = {
	flexShrink: 0,
	minWidth: COUNT_BADGE_SIZE,
	padding: "0 6px",
	borderRadius: "var(--radius-full)",
	background: "var(--accent-subtle)",
	color: "var(--accent)",
	fontFamily: "var(--font-mono)",
	fontSize: "var(--text-section)",
	fontWeight: 500,
	lineHeight: `${COUNT_BADGE_SIZE}px`,
	textAlign: "center",
};
